import PRIVACY from "@/data/privacy.json";
import { useSeo } from "@/lib/site";
import { MaskedLines, FadeIn } from "@/components/site/Motion";

export default function Privacy() {
  useSeo("Privacy Policy | Perfect Digitals", "How Perfect Digitals collects, stores and processes personal data, and how we use cookies.");
  return (
    <div data-testid="privacy-page">
      <section className="grain relative overflow-hidden bg-ink pb-16 pt-36 text-white sm:pt-44">
        <div aria-hidden="true" className="absolute right-[-10%] top-[-20%] h-[520px] w-[520px] rounded-full bg-violet-700/25 blur-[140px]" />
        <div className="wrap relative">
          <FadeIn className="font-mono text-[11px] uppercase tracking-[0.25em] text-violet-300">Legal</FadeIn>
          <MaskedLines testid="privacy-title" lines={["Privacy", <span className="font-serif-i text-gradient">Policy</span>]} className="mt-6 font-display text-[3rem] font-medium leading-[0.95] sm:text-7xl" />
        </div>
      </section>
      <section className="bg-[#FAFAFC] py-16 sm:py-24">
        <div className="prose-pd privacy mx-auto max-w-3xl px-5 sm:px-8" data-testid="privacy-content" dangerouslySetInnerHTML={{ __html: PRIVACY.html }} />
      </section>
    </div>
  );
}
